import { render, staticRenderFns } from "./pagnation.vue?vue&type=template&id=f799e57a&scoped=true&"
import script from "./pagnation.vue?vue&type=script&lang=js&"
export * from "./pagnation.vue?vue&type=script&lang=js&"
import style0 from "./pagnation.vue?vue&type=style&index=0&id=f799e57a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f799e57a",
  null
  
)

export default component.exports